import { z } from 'zod';
import { employeeDetailedSchema } from '../../GET/employee/response';
import { id } from '../../common/atomic/id';

export const updateEmployeeSchema = employeeDetailedSchema
  .omit({
    id: true,
    access: true,
    active: true,
    contractEnd: true,
    tags: true,
    locs: true,
    optimum: true,
  })
  .merge(
    z.object({
      tags: z.array(id),
      locs : z.array(id),
    })
  );

export type UpdateEmployee = z.infer<typeof updateEmployeeSchema>;
